import css from '@emotion/css';
import styled from '@emotion/styled';

export const StyledInfoWrapper = styled.div`
  ${({ isInheritedPercentage }) =>
    isInheritedPercentage
      ? css`
          display: flex;
          justify-content: space-between;
          width: 70px; // ensures a minimum of 10px padding on the right
          gap: 10px;
        `
      : ''}
`;
